import { createContext } from "react";

export const LeagueContext = createContext({
  leagueCode: "",
  checkboxCheckedStates: [],
  triggerClassicPublicLeagueRefetch: false,
  isLeagueMarketingPage: false,
  leagueInfoSuccessData: {},
  isAgeGateUnverified: false,
  updateLeagueCode: () => {},
  updateCheckboxCheckedStates: () => {},
  updateTriggerClassicPublicLeagueRefetch: () => {},
  updateIsLeagueMarketingPage: () => {},
  updateLeagueInfoSuccessData: () => {},
  updateIsAgeGateUnverified: () => {},
});
